import React from "react";
import LegalLayout from "./LegalLayout";

const Terms = () => (
  <LegalLayout
    title="Terms of Service"
    updated="June 2026"
    intro={[
      "These Terms of Service (\"Terms\") govern your access to and use of the StayFlow mobile application and the website at www.stayflowapp.in (together, the \"Service\"), operated by StayFlow (\"StayFlow\", \"we\", \"us\", or \"our\").",
      "By creating an account or using the Service, you agree to be bound by these Terms. If you do not agree, do not use the Service.",
    ]}
    sections={[
      {
        heading: "Eligibility & Accounts",
        body: [
          "You must be at least 18 years old and capable of forming a binding contract to use the Service. The Service is intended for businesses and their authorized staff.",
          "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Notify us immediately of any unauthorized use.",
        ],
      },
      {
        heading: "Description of the Service",
        body: [
          "StayFlow provides a hospitality operating system that may include room and table management, an interactive booking calendar, a built-in kitchen point-of-sale (POS) and kitchen display system (KDS), AI Smart Booking, offline capability with automatic sync, and tools for managing guests, staff, and financial records.",
          "We may add, modify, or discontinue features from time to time to improve the Service.",
        ],
      },
      {
        heading: "Acceptable Use",
        body: [
          "You agree not to:",
          {
            list: [
              "Use the Service for any unlawful, fraudulent, or unauthorized purpose.",
              "Upload content you do not have the right to use, or that infringes the rights of others.",
              "Attempt to gain unauthorized access to the Service, other accounts, or our systems.",
              "Interfere with or disrupt the integrity or performance of the Service.",
              "Reverse engineer, decompile, or attempt to extract source code except as permitted by law.",
            ],
          },
        ],
      },
      {
        heading: "Your Content & Data",
        body: [
          "You retain all rights to the data and content you submit to the Service (\"Your Content\"), including bookings, orders, guest records, and uploaded images.",
          "You grant StayFlow a limited license to host, process, and transmit Your Content solely to operate and provide the Service to you, including AI processing of images you upload for AI Smart Booking.",
          "You are responsible for the accuracy and legality of Your Content and for obtaining any consents required from your guests and staff.",
        ],
      },
      {
        heading: "AI Features",
        body: [
          "AI Smart Booking and similar features are provided to assist you and may not always be accurate. You are responsible for reviewing and confirming any information generated or pre-filled by AI before relying on it.",
        ],
      },
      {
        heading: "Payments & Subscriptions",
        body: [
          "Certain features may require a paid subscription. If you purchase through the Apple App Store or Google Play, billing is handled by that platform and is subject to its terms. Fees are non-refundable except where required by law or the applicable platform's policies.",
        ],
      },
      {
        heading: "Intellectual Property",
        body: [
          "The Service, including its software, design, and trademarks, is owned by StayFlow and protected by applicable intellectual property laws. These Terms do not grant you any right to use our branding without prior written consent.",
        ],
      },
      {
        heading: "Third-Party Platforms",
        body: [
          "The Service is distributed and may operate through third-party platforms, including the Apple App Store, Google Play, and services associated with Meta. Your use of those platforms is governed by their respective terms. Those platforms are not parties to these Terms and are not responsible for the Service.",
        ],
      },
      {
        heading: "Disclaimer of Warranties",
        body: [
          "The Service is provided \"as is\" and \"as available\" without warranties of any kind, whether express or implied, including fitness for a particular purpose and non-infringement. We do not warrant that the Service will be uninterrupted, error-free, or fully secure.",
        ],
      },
      {
        heading: "Limitation of Liability",
        body: [
          "To the maximum extent permitted by law, StayFlow shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of data, revenue, or profits arising from your use of the Service.",
        ],
      },
      {
        heading: "Termination",
        body: [
          "You may stop using the Service at any time. We may suspend or terminate your access if you violate these Terms or if we discontinue the Service. Upon termination, provisions that by their nature should survive will remain in effect.",
        ],
      },
      {
        heading: "Governing Law",
        body: [
          "These Terms are governed by the laws of India, without regard to conflict-of-law principles. Any disputes shall be subject to the courts having jurisdiction in Assam, India.",
        ],
      },
      {
        heading: "Changes to These Terms",
        body: [
          "We may update these Terms from time to time. We will post the updated version on this page and revise the \"Last updated\" date. Continued use of the Service after changes constitutes acceptance of the updated Terms.",
        ],
      },
      {
        heading: "Contact Us",
        body: [
          "For questions about these Terms, contact us at stayflow.admin@gmail.com or by post at StayFlow, 163, Jyoti Nagar, Bongaon, Part - 3, Golaghat, Assam - 785621 (India).",
        ],
      },
    ]}
  />
);

export default Terms;
